import React from 'react';
import { Twitter, Linkedin, Instagram, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-black border-t border-gray-900 text-gray-400 py-16" data-id="element-189">
      <div className="container mx-auto px-4 md:px-6" data-id="element-190">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-12 mb-16" data-id="element-191">
          <div className="col-span-2 lg:col-span-2" data-id="element-192">
            <img src="https://cdn.magicpatterns.com/uploads/woWdE3SqvP2mw6xTq283GZ/Screenshot_2025-12-07_085625.png" alt="Absolute Insurance Brokers" className="h-12 w-auto mb-6" data-id="element-193" />
            <p className="max-w-xs mb-6" data-id="element-194">
              Trusted insurance brokers providing comprehensive protection for
              your assets, family, and future since 2022.
            </p>
            <div className="flex gap-4" data-id="element-195">
              {[Twitter, Linkedin, Instagram, Facebook].map((Icon, i) => <a key={i} href="#" className="hover:text-brand-red transition-colors" data-id="element-196">
                  <Icon className="h-5 w-5" data-id="element-197" />
                </a>)}
            </div>
          </div>

          <div data-id="element-198">
            <h4 className="text-white font-bold mb-6" data-id="element-199">Product</h4>
            <ul className="space-y-4" data-id="element-200">
              {['Features', 'Pricing', 'Coverage', 'Claims', 'App'].map(item => <li key={item} data-id="element-201">
                    <a href="#" className="hover:text-white transition-colors" data-id="element-202">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>

          <div data-id="element-203">
            <h4 className="text-white font-bold mb-6" data-id="element-204">Company</h4>
            <ul className="space-y-4" data-id="element-205">
              {['About', 'Careers', 'Press', 'Blog', 'Contact'].map(item => <li key={item} data-id="element-206">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-207">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-208">
            <h4 className="text-white font-bold mb-6" data-id="element-209">Legal</h4>
            <ul className="space-y-4" data-id="element-210">
              {['Privacy', 'Terms', 'Security', 'Licenses'].map(item => <li key={item} data-id="element-211">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-212">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-900 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-213">
          <p data-id="element-214">
            &copy; 2024 Absolute Insurance Brokers Limited. All rights reserved.
          </p>
          <div className="flex gap-8" data-id="element-215">
            <a href="#" className="hover:text-white" data-id="element-216">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white" data-id="element-217">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}